import auth from '../utils/auth';
import axios from 'axios';

export function verifySession(user_id) {
    return axios.request({
        url: `/customers/session/verify?customer_id=${user_id}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function getUser(user_id) {
    return axios.request({
        url: `/customers/${user_id}`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function saveUser(user_id, data) {
    return axios.request({
        url: `/customers/${user_id}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: data
    });
}

export function removeUser(user_id) {
    return axios.request({
        url: `/customers/${user_id}`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export const processLogin = async (username, password) => {
    let { data } = await axios.request({
        url: `/customers/login`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        data: {
            email: username,
            password: password
        }
    });
    auth.setSID(data.session_key);
    auth.setUserId(data.customer_id);
    auth.setToken(data.jwt);
    return data;
    // let { data: user } = await getUser(data.customer_id);
    // return user;
};

export function registerUser(user_data) {
    return axios.request({
        url: `/customers`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        body: JSON.stringify(user_data)
    });
}

export function registerOrg(org_info, sessionkey) {
    return axios.request({
        url: `/entities`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': sessionkey
        },
        body: JSON.stringify(org_info)
    });
}

function sanitizeGrid(grid_data) {
    let black_list = ['_id', '_created', '_modified', 'customer_id'];
    let clean_grid = {};
    Object.keys(grid_data)
        .filter((key) => !black_list.includes(key))
        .forEach((key) => {
            clean_grid[key] = grid_data[key];
        });
    return clean_grid;
}

export function createUserGrids(customer_id) {
    return axios.request({
        url: `/customers/${customer_id}/grids`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function saveGrid(customer_id, grid_id, grid_data) {
    return axios.request({
        url: `/customers/${customer_id}/grids/${grid_id}`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: sanitizeGrid(grid_data)
    });
}

export function setNlSignup(customer_id, nl_signup) {
    return axios.request({
        url: `/customers/${customer_id}/nl-signup`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        }
    });
}

export function forgotPassword(email) {
    return axios.request({
        url: `/customers/forgot`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Session-Key': auth.getSID()
        },
        data: {
            email: email
        }
    });
}
